const EmailFonts: string = `
<style>
@import url('https://fonts.googleapis.com/css2?family=Bellefair&family=David+Libre:wght@400;500;700&display=swap');
</style>

`;


export default EmailFonts